module.exports = __webpack_public_path__ + "img/toolmail.f72eea97.svg";